import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnlinkItemLocationFromDeliveryAddressMutationVariables = Types.Exact<{
  delivery_address_id: Types.Scalars['ID'];
  item_location_id: Types.Scalars['ID'];
}>;


export type UnlinkItemLocationFromDeliveryAddressMutation = { __typename?: 'Mutation', unlinkItemLocationFromDeliveryAddress: { __typename?: 'EventDeliveryAddress', id: string, name?: string | null, event_id?: string | null, is_event_default: boolean, linked_item_location_count: number } };


export const UnlinkItemLocationFromDeliveryAddressDocument = gql`
    mutation UnlinkItemLocationFromDeliveryAddress($delivery_address_id: ID!, $item_location_id: ID!) {
  unlinkItemLocationFromDeliveryAddress(
    delivery_address_id: $delivery_address_id
    item_location_id: $item_location_id
  ) {
    id
    name
    event_id
    is_event_default
    linked_item_location_count
  }
}
    `;
export type UnlinkItemLocationFromDeliveryAddressMutationFn = Apollo.MutationFunction<UnlinkItemLocationFromDeliveryAddressMutation, UnlinkItemLocationFromDeliveryAddressMutationVariables>;

/**
 * __useUnlinkItemLocationFromDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useUnlinkItemLocationFromDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkItemLocationFromDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkItemLocationFromDeliveryAddressMutation, { data, loading, error }] = useUnlinkItemLocationFromDeliveryAddressMutation({
 *   variables: {
 *      delivery_address_id: // value for 'delivery_address_id'
 *      item_location_id: // value for 'item_location_id'
 *   },
 * });
 */
export function useUnlinkItemLocationFromDeliveryAddressMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkItemLocationFromDeliveryAddressMutation, UnlinkItemLocationFromDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkItemLocationFromDeliveryAddressMutation, UnlinkItemLocationFromDeliveryAddressMutationVariables>(UnlinkItemLocationFromDeliveryAddressDocument, options);
      }
export type UnlinkItemLocationFromDeliveryAddressMutationHookResult = ReturnType<typeof useUnlinkItemLocationFromDeliveryAddressMutation>;
export type UnlinkItemLocationFromDeliveryAddressMutationResult = Apollo.MutationResult<UnlinkItemLocationFromDeliveryAddressMutation>;
export type UnlinkItemLocationFromDeliveryAddressMutationOptions = Apollo.BaseMutationOptions<UnlinkItemLocationFromDeliveryAddressMutation, UnlinkItemLocationFromDeliveryAddressMutationVariables>;